/* global axios */

import ApiClient from './ApiClient';

class FoodicsAPI extends ApiClient {
  constructor() {
    super('foodics', { accountScoped: true });
  }

  status() {
    return axios.get(`${this.url}/status`);
  }

  authUrl() {
    return axios.get(`${this.url}/auth_url`);
  }

  branches({ page = 1 } = {}) {
    return axios.get(`${this.url}/branches`, { params: { page } });
  }

  customers({ page = 1, search = '' } = {}) {
    return axios.get(`${this.url}/customers`, { params: { page, search } });
  }

  orders({ referenceAfter = '0', customerId = '' } = {}) {
    const params = { reference_after: referenceAfter };
    if (customerId) params.customer_id = customerId;

    return axios.get(`${this.url}/orders`, {
      params,
    });
  }

  importCustomer(customer) {
    return axios.post(`${this.url}/import_customer`, { customer });
  }

  disconnect() {
    return axios.delete(`${this.url}/disconnect`);
  }
}

export default new FoodicsAPI();
